module.exports = __webpack_public_path__ + "static/media/logo.8bd3ef1b.png";